import React from 'react';
import LandingPage from './pages/LandingPage';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <>
      <LandingPage />
      <Toaster position="top-center" richColors />
    </>
  );
}

export default App;